import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import Reatilers from "app/pages/MyBranches";
import AddEditRetailer from "app/pages/MyBranches/AddEditRetailer";


const routesName = "/dashboards/myBranch";
const modules = "myBranch";

export const myBranchRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
        module: modules
      },
    ],
    routes: [
      {
        path: `${routesName}`,
        element: <Page component={Reatilers} />
      },
      {
        path: `${routesName}/add`,
        element: <Page component={AddEditRetailer} />,
      },
      {
        path: `${routesName}/edit/:id`,
        element: <Page component={AddEditRetailer} />,
      },
    ],
  },]
  